export default __webpack_public_path__ + "static/media/list-bg.c38f8a9a.svg";